module.exports = __webpack_public_path__ + "media/hyper/images/maintenance-08340144a4528afbb7aff8b1130b5ae6.svg";